import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
})

export const postSessionBypass = () => {
  const queryParams = new URLSearchParams(window.location.search)

  if (queryParams.has('jwt')) {
    return instance.post('/sso/bypass', {
      jwt: queryParams.get('jwt')
    })
  }

  return new Promise((resolve, reject) => {
    if (process.env.REACT_APP_ENV === 'development') {
      return resolve()
    }

    return reject()
  })
}

export const updateDocument = async content => {
  return await instance.put(`/content`, { content: content })
}

export const getDocument = async () => {
  return await instance.get(`/content`)
}

export const fetchPrediction = questions => {
  return instance.post('/predict', { questions: questions })
}

export default instance



// WEBPACK FOOTER //
// ./src/utils/api.js